import React from 'react';
import './styles.scss'

const Loading = () => (
    <div className="loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default Loading;
